import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './HomePage.css';

import TopNav from '../components/TopNav';

import InsigniaRank from '../components/InsigniaRank';
import InsigniaAWO from '../components/InsigniaAWO';
import Certificate from '../components/Certificate';
/**
 * Dashboard Component
 * Displays comprehensive Virtual Airline pilot statistics and activity.
 * Data is sourced from localStorage 'userData'.
 */
const HomePage = (props) => {
    const navigate = useNavigate();
    const [pilotData, setPilotData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [darkMode, setDarkMode] = useState(false);
    const [showRefreshModal, setShowRefreshModal] = useState(false);

    useEffect(() => {
        console.log("useEffect");
        try {
            const data = localStorage.getItem('userData');
            if (data) {
                const parsedData = JSON.parse(data);
                if (parsedData.login === "OK") {
                    setPilotData(parsedData);

                } else {
                    setError("Authentication failed or invalid data structure.");
                }
            } else {
                handleRefresh();
            }
        } catch (err) {
            setError("Error accessing pilot records.");
            console.error(err);
        } finally {
            setLoading(false);
        }


    }, []);

    // Update darkMode when props change
    useEffect(() => {
        setDarkMode(props.darkmode);
    }, [props.darkmode]);

    const toggleTheme = () => props.toggle();

const handleRefresh = async () => {
    console.log("refresh");
    setShowRefreshModal(true);

    try {
        await props.refreshUser();                     // fetchUserData() — no return value, but stores in localStorage
        const data = localStorage.getItem('userData'); // read what it just stored
        if (data) {
            const parsedData = JSON.parse(data);
            if (parsedData.login === "OK") {
                setPilotData(parsedData);
            } else {
                setError("Authentication failed or invalid data structure.");
            }
        } else {
            setError("Unable to retrieve data.");
        }
    } catch (err) {
        setError("Error: " + err);
        console.error(err);
    } finally {
        setLoading(false);
        setTimeout(() => {
            setShowRefreshModal(false);
        }, 3000);
    }
};


    if (loading) return <div className="dash-loader">Loading...please wait</div>;
    if (error) return <div className="dash-error">Error: {error}</div>;
    if (!pilotData) return null;
 
    // Helper to calculate percentages safely
    const getPercent = (value, total) => {
        if (!total || total === 0) return 0;
        return ((value / total) * 100).toFixed(1);
    };


async function handleLogout() {
    try {
        await axios.post('/api/logout', { iid: props.iid }, { withCredentials: true });    
    } catch (err) {
        console.warn("Logout API call failed:", err);
    } finally {
        // Delegate all client-side cleanup to App.js via the onLogout callback.
        // App.js sets a useRef guard, clears localStorage/state, and sets
        // loggedIn=false — which causes React to re-render to /login without
        // a full page reload, eliminating the sessionStorage race condition.
        if (props.onLogout) {
            props.onLogout();
        }
    }
}


    return (
        <div className={`dashboard-container ${darkMode ? 'dark-theme' : 'light-theme'}`}>
            {showRefreshModal && (
                <div className="refresh-modal-overlay">
                    <div className="refresh-modal">
                        <p>Refreshing data</p>
                    </div>
                </div>
            )}
            <TopNav page={props.page} darkMode={props.darkmode} />
            {/* Header / Quick Actions */}
            <div className="dash-header">
                <div className="dash-title-group">
                    <h1>{pilotData.fullname}, {pilotData.callsign} </h1>
                    <div className="dash-admin-title">{props?.admin?.title} </div>
                    <span className="status-indicator">
                        <span className="pulse-dot"></span> Location: {pilotData.location}
                         
                    </span>
                    
                </div>
                <div className="dash-controls">
                    <button className="theme-toggle" onClick={toggleTheme}>
                        {props.darkmode ? '☀️' : '🌙'}
                    </button>
                    <div className="quick-actions">

                        <button className="btn-action" onClick={() => navigate('/user-profile')}>Edit Profile</button>
                    </div>
                </div>
            </div>

            <div className="dash-grid">
                
                {/* Section 1: Member Profile & Rank */}
                <section className="dash-card profile-card">
                    <div className="card-header card-header-with-refresh">
                        {/* <i className="icon-user"></i> */}
                        <h3>FDXVA Service Record</h3>
                        <button
                            className="btn-refresh btn-refresh-header"
                            onClick={handleRefresh}
                            title="Refresh data"
                            aria-label="Refresh data"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
                                <polyline points="23 4 23 10 17 10" />
                                <polyline points="1 20 1 14 7 14" />
                                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                            </svg>
                        </button>
                    </div>
                    <div className="profile-content">
                        <div className="rank-info">
                            <div className="label">
                                <InsigniaRank rank={pilotData.rank} /> 
                                <span className="value highlight">{pilotData.rank}</span>
                            </div>
                            
                            <div className="progress-container">
                                <div className="progress-bar" style={{ width: `${pilotData.rankProgress}%` }}></div>
                            </div>
                            <span className="progress-text">{pilotData.rankProgress}% to next promotion</span>
                        </div>
                        <div className="profile-stats-row">
                            <div className="stat-item">
                                <span className="label">FLIGHTS</span>
                                <span className="value status-warn">{pilotData.totalflights}</span>
                            </div>
                            
                                                        <div className="stat-item">
                                <span className="label">HOURS</span>
                                <span className="value">{Math.round(pilotData.hours,1)}</span>
                            </div>
                            <div className="stat-item">
                                <span className="label">Last Flight</span>
                                <span className="value">{pilotData.flightdateStr}</span>
                            </div>

                        </div>
                        <div className="status-message">
                            <span className="status-message-text">{pilotData.mystatus}</span>
                        </div>
                    </div>
                </section>

                {/* Section 2: Notifications / Real-time Status */}
                <section className="dash-card alerts-card">
                    {(pilotData.cat23 !== "" || pilotData.charterCert !== 0 || pilotData.ferryCert !== 0) && <div>
                        <div className="card-header">
                            <h3>Endorsements</h3>
                        </div>
                        <div className="alerts-list">
                            {pilotData.cat23 !== "" && (
                                <div className="alert-item success">
                                    <span className="alert-icon">
                                        <InsigniaAWO awo="cat23" />
                                    </span>
                                    <p className='dashboard-endorsement'>{pilotData.cat23_descrip}</p>
                                </div>
                            )}                        
                            {pilotData.charterCert !== 0 && (
                                <div className="alert-item success">
                                    <span className="alert-icon">
                                        <Certificate cert="charter" />
                                    </span>
                                    <p className='dashboard-endorsement'>Charter Certification</p>
                                </div>
                            )}
                            {pilotData.ferryCert !== 0 && (
                                <div className="alert-item success">
                                    <span className="alert-icon">
                                        <Certificate cert="ferry" />
                                    </span>
                                    <p className='dashboard-endorsement'>Ferry Certification</p>
                                </div>
                            )}
                        </div>
                    </div>}

                    {(pilotData.cat23 === "" && pilotData.charterCert === 0 && pilotData.ferryCert === 0) && <div>
                        <div className="card-header">
                            <h3>Recent Flights</h3>
                        </div>
                        <div className="recent-flights-wrapper">
                            {pilotData.recentFlights.length > 0 ? (
                                <table className="recent-flight-table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Date</th>
                                            <th>Origin</th>
                                            <th>Destination</th>
                                            <th>Hours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pilotData.recentFlights.map((flight, index) => {
                                            const fmtDate = (() => {
                                                const d = new Date(Number(flight.date) * 1000);
                                                return isNaN(d) ? flight.date : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
                                            })();
                                            const fmtHours = (() => {
                                                const h = parseFloat(flight.hours);
                                                return isNaN(h) ? flight.hours : h.toFixed(1);
                                            })();
                                            return (
                                            <tr key={index} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                                                <td className="flight-status">✅</td>
                                                <td>{fmtDate}</td>
                                                <td className="airport-code">{flight.orig}</td>
                                                <td className="airport-code">{flight.dest}</td>
                                                <td className="flight-hours">{fmtHours}</td>
                                            </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <p className="no-flights-msg">Time to fly! This section will contain your recent approved flight reports.</p>
                            )}
                        </div>
                    </div>}


                </section>

                {/* Section 3: Year-To-Date (YTD) Activity */}
                <section className="dash-card full-width">
                    <div className="card-header">
                        <span>⏳ &nbsp;</span>
                        <h3>Year-To-Date Activity </h3>
                    </div>
                    <div className="stats-grid-activity">
                        <div className="mini-stat">
                            <span className="label">Flights</span>
                            <span className="value">{pilotData.ytdflights + (pilotData.ytdnight || 0)}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Hours</span>
                            <span className="value">{pilotData.ytdhours}h</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Distance (NM)</span>
                            <span className="value">{Number(pilotData.ytdnm).toLocaleString()}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Airports</span>
                            <span className="value">{pilotData.ytdairport}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Countries</span>
                            <span className="value">{pilotData.ytdcountry}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Airframes</span>
                            <span className="value">{pilotData.ytdairframe}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Cargo (Lbs)</span>
                            <span className="value">{Number(pilotData.ytdcargo).toLocaleString()}</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">On-Time</span>
                            <span className="value">{Math.round(100*pilotData.ytdontime / pilotData.ytdflights,1)}%</span>
                        </div>
                        <div className="mini-stat">
                            <span className="label">Avg Landing</span>
                            <span className="value">{pilotData.ytdfpm} fpm</span>
                        </div>
                    </div>
                </section>

                {/* Section 4: Pilot Career Comprehensive Section */}
                <section className="dash-card full-width career-section">
                    <div className="card-header">
                        <span className="icon-globe"> ♾️ &nbsp; </span>
                        <h3>Lifetime Career Statistics</h3>
                    </div>
                    <div className="career-container">
                        <div className="career-main-metrics">
                            <div className="metric-box">
                                <h4>{pilotData.totalflights}</h4>
                                <span>Total Flights</span>
                                <br />
                                <button onClick={() => navigate('/logbook')} className='btn-view-logbook'>View Logbook</button>
                                
                            </div>
                            <div className="metric-box">
                                <h4>{pilotData.totalhours}</h4>
                                <span>Total Hours</span>
                            </div>
                            <div className="metric-box">
                                <h4>{Number(pilotData.sumdist).toLocaleString()}</h4>
                                <span>Total NM</span>
                            </div>
                            <div className="metric-box">
                                <h4>{pilotData.airports}</h4>
                                <span>Airports</span>
                            </div>
                        </div>

                        <div className="career-details-grid">
                            {/* Breakdown Column 1 */}
                            <div className="details-col">
                                <h5>Flight Efficiency</h5>
                                <ul>
                                    <li><span>Avg Distance:</span> <strong>{(pilotData.sumdist / pilotData.totalflights).toFixed(0)} NM</strong></li>
                                    <li><span>Avg Hours:</span> <strong>{(pilotData.totalhours / pilotData.totalflights).toFixed(1)}</strong></li>
                                    <li><span>Avg Landing:</span> <strong>{pilotData.avglandfpm} fpm</strong></li>
                                    <li><span>On-Time:</span> <strong>{getPercent(pilotData.ontime, pilotData.totalflights)}%</strong></li>
                                    <li><span>IFR / LIFR:</span> <strong>{getPercent(pilotData.ifr, pilotData.totalflights)}%</strong></li>
                                </ul>
                            </div>

                            {/* Breakdown Column 2: Operation Types (Counts) */}
                            <div className="details-col">
                                <h5>Flight Types (Qty)</h5>
                                <ul>
                                    <li><span>System:</span> <strong>{pilotData.systemflights} ({getPercent(pilotData.systemflights, pilotData.totalflights)}%)</strong></li>
                                    <li><span>Charter:</span> <strong>{pilotData.charterflights} ({getPercent(pilotData.charterflights, pilotData.totalflights)}%)</strong></li>
                                    <li><span>Ferry:</span> <strong>{pilotData.ferryflights} ({getPercent(pilotData.ferryflights, pilotData.totalflights)}%)</strong></li>
                                    <li><span>Night Ops:</span> <strong>{pilotData.nightland}</strong></li>
                                </ul>
                            </div>

                            {/* Breakdown Column 3: Hours Breakdown */}
                            <div className="details-col">
                                <h5>Hours Breakdown</h5>
                                <ul>
                                    <li><span>System Hrs:</span> <strong>{Math.round(pilotData.systemhours,1)} ({getPercent(pilotData.systemhours, pilotData.totalhours)}%)</strong></li>
                                    <li><span>Charter Hrs:</span> <strong>{Math.round(pilotData.charterhours)} ({getPercent(pilotData.charterhours, pilotData.totalhours)}%)</strong></li>
                                    <li><span>Ferry Hrs:</span> <strong>{Math.round(pilotData.ferryhours)} ({getPercent(pilotData.ferryhours, pilotData.totalhours)}%)</strong></li>
                                    <li><span>Total Cargo:</span> <strong>{Number(pilotData.cargo).toLocaleString()} lbs</strong></li>
                                </ul>
                            </div>

                            {/* Breakdown Column 4: Experience */}
                            <div className="details-col">
                                <h5>Experience</h5>
                                <ul>
                                    <li><span>Active Tenure:</span> <strong>{pilotData.activeTenure} Months</strong></li>
                                    <li><span>Unique Airframes:</span> <strong>{pilotData.airframes}</strong></li>
                                    <li><span>Countries:</span> <strong>{pilotData.countries}</strong></li>
                                    <li><span  className='btn-view-logbook' onClick={() => navigate('/ledger')}>Ledger Balance:</span> <strong>${Number(pilotData.funds).toLocaleString()}</strong>

                                    </li>
                                </ul> 
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
            <footer className="dash-footer">
                  <div onClick={handleLogout} className='dash-logout'>Logout</div>
{/* Pilot Log Reference ID: {pilotData.iid} | Internal Staff ID: {pilotData.staff || 'N/A'}                   */}
            </footer>
        </div>
    );
};

export default HomePage;